import moment from 'moment';
// usage: {{dateObj | date}}
export default function timeago(date) {
  if (!date) return date;
  return moment(date).fromNow();
}
